import Vue from 'vue'
import Router from 'vue-router'

// Views
const LayoutEmpty = () => import('@/views/Empty');
const Login = () => import('@/views/Login');
const Welcome = () => import('@/views/Welcome');
const Help = () => import('@/views/Help');
const SequenceTest = () => import('@/views/sequence/Test');
const SequenceBeforeStep = () => import('@/views/sequence/BeforeStep');
const SequenceStep = () => import('@/views/sequence/Step');
const SequenceDone = () => import('@/views/sequence/Done');
const PageNotFound = () => import('@/views/Page404');

Vue.use(Router);

export default new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({y: 0}),
    routes: [
        {
            path: '/',
            component: LayoutEmpty,
            beforeEnter: (to, from, next) => {
                if(!Vue.prototype.$state.logged_in) {
                    // Redirect to login if not authenticated.
                    return next({name: 'login'});
                }
                Vue.prototype.$api.login(Vue.prototype.$state.logged_in)
                .then((response) => {

                    if (response.data.errortext) {
                        window.Vue.log('Error when resuming: ' + response.data.errortext, true);
                        localStorage.removeItem('MOVAVIEW_LOGIN_INFO');
                        localStorage.removeItem('MOVAVIEW_LOGIN');
                        return next({name: 'login'});
                    }

                    window.Vue.log('Logged in again');
                    Vue.prototype.$state.login_info = response.data;

                    if((to.name === "sequenceBeforeStep" || to.name === "sequenceStep") && !window.stream)
                        return next({name: 'test'});

                }).catch((error) => {
                    return next({name: 'login'});
                });

                return next();
            },
            children: [
                {
                    path: '/',
                    name: 'welcome',
                    component: Welcome,
                },
                {
                    path: '/test',
                    name: 'test',
                    component: SequenceTest,
                }, {
                    path: '/before-step',
                    name: 'sequenceBeforeStep',
                    component: SequenceBeforeStep
                }, {
                    path: '/step',
                    name: 'sequenceStep',
                    meta: {
                        layout: 'video',
                    },
                    component: SequenceStep
                }, {
                    path: '/done',
                    name: 'sequenceDone',
                    component: SequenceDone
                },
                {
                    path: '/logout',
                    name: 'logout',
                    beforeEnter: (to, from, next) => {
                        localStorage.removeItem('MOVAVIEW_LOGIN');
                        localStorage.removeItem('MOVAVIEW_LOGIN_INFO');

                        return next({name: 'login'});
                    }
                },
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            beforeEnter: (to, from, next) => {
                // Redirect to start if authenticated.
                if(Vue.prototype.$state.logged_in) {
                    return next({name: 'welcome'});
                }
                return next();
            }
        },
        {
            path: '/help',
            name: 'help',
            component: Help
        },
        {
            path: '*',
            name: '404',
            component: PageNotFound
        }
    ]
})
